import "./App.css";
import Main from ".//components/main/Main.jsx";
import Program from ".//components/program/Program.jsx";
import Reasons from "./components/Reasons/Reasons";
import Plans from "./components/Plans/Plans";
import Testimonials from "./components/Testimonials/Testimonials";
import Join from "./components/Join/Join";
import Footer from "./components/Footer/Footer";
function App() {
  return (
    <div className="App">
      <Main />
      <Program />
      <Reasons />
      <Plans />
      <Testimonials />
      <Join/>
      <Footer/>
    </div>
  );
}

export default App;
